import React from "react"
import "./index.css"

const FooterWidgets = () => {
  return (
    <React.Fragment>
      <section id="footer-widgets-section">
        <div className="container">
          <div className="row">
            <div className="col-md-4 footer-widget">
              <h3>Addresse</h3>
              <p>
                Lorem Ipsum has been the industry's standard dummy text ever
                since the 1500s
              </p>
            </div>

            <div className="col-md-4 footer-widget">
              <h3>Addresse</h3>
              <p>
                Lorem Ipsum has been the industry's standard dummy text ever
                since the 1500s
              </p>
            </div>

            <div className="col-md-4 footer-widget">
              <h3>Addresse</h3>
              <p>
                Lorem Ipsum has been the industry's standard dummy text ever
                since the 1500s
              </p>
              <p>
                Lorem Ipsum has been the industry's standard dummy text ever
                since the 1500s
              </p>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  )
}

export default FooterWidgets
